import {Device} from '@fantasmagames/core/src/device/Device';

export interface IPreloader {
	createLoadingScreen(): void;

	endLoading(): void;

	updateProgress(totalItems: number, current: number): void;

	usingUnsupportedDeviceOrBrowser(): void;
}

export class Preloader implements IPreloader {
	protected _loaderBar: HTMLElement;
	protected _loaderBarBg: HTMLElement;
	protected _fantasmaLogo: HTMLImageElement;

	protected _gameLogo: HTMLImageElement;
	protected _publisherLogoPortrait: HTMLImageElement;
	protected _publisherLogoLandscape: HTMLImageElement;
	protected _loadingImage: HTMLImageElement;

	protected _loadingBackground: HTMLElement;
	protected _getUrlPath: Function;

	protected _isMobile: boolean;

	protected _device: Device;
	protected locale: string = 'EN';

	protected _debuggingText: HTMLElement;

	protected _useDebugging: boolean;
	protected resizeFunction: any;

	protected _procentageLoaded: number = 0;

	protected _loaderBarMaxWidth: number;
	constructor(baseUrlPath: Function, device: Device) {
		this._getUrlPath = baseUrlPath;
		this._isMobile = device.isMobile;
		this._device = device;

		this.resizeFunction = this.onResizeEvent.bind(this);
	}

	protected getDevicePathForResource(resName: string): string {
		const platformPath: string = this._isMobile ? 'resources/Mobile/' : 'resources/Desktop/';

		return this._getUrlPath(platformPath + resName);
	}

	public createLoadingScreen(): void {
		document.body.style.backgroundColor = 'black';

		const parentItem: HTMLElement = document.getElementById('preloader');

		const preloaderBg: HTMLElement = this.createLoadingPreloaderBg();
		if (preloaderBg) {
            parentItem.appendChild(preloaderBg);
        }

		const bg: HTMLElement = this.createLoadingBarBg();
		if (bg) {
            parentItem.appendChild(bg);
        }

		const progress: Node = this.createLoadingBarProgress(bg);
		if (progress) {
            parentItem.appendChild(progress);
        }

		const loadingText: HTMLElement = this.createLoadingText();
		if (loadingText) {
            parentItem.appendChild(loadingText);
        }

		this.addExtraItems(parentItem);

		this._useDebugging = false;

		this.onResizeEvent();

		setTimeout(() => {
			this.onResizeEvent();
		}, 500);

		window.addEventListener('resize', this.resizeFunction);
	}

	protected addExtraItems(parentItem?: HTMLElement): void {
	}

	protected createDebuggingDiv(parentItem: HTMLElement): void {
		const debuggingText: HTMLElement = document.createElement('div');

		debuggingText.id = 'debuggingElement';
		debuggingText.style.position = 'absolute';
		debuggingText.innerText = 'DEBUGGER';
		debuggingText.style.color = 'white';
		debuggingText.style.top = '50px';
		debuggingText.style.zIndex = '10000';

		this._debuggingText = debuggingText;

		parentItem.appendChild(debuggingText);
	}

	protected updateDebugger(data: any): void {
		let dataText = '';
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				const element = JSON.stringify(data[key]);
				dataText += `<br/>${key}:${element}`;
			}
		}

		this._debuggingText.innerHTML = dataText;
	}

	protected onResizeEvent(): void {
		setTimeout(
			() => {
				this.scalePreloaderComponents();
			},
			(this._device.iOS && this._device.isIOSChrome) || this._device.isIOSMobileRequestingDesktop ? 200 : 0,
		);
	}

	protected scalePreloaderComponents(): void {
		let w: number = 0;
		let h: number = 0;

		let ow: number = 0;
		let oh: number = 0;

		let scaleFactor: number = 1;

		const innerWidth: number = this._device.isSamsungNative ? window.outerWidth : window.innerWidth;
		const innerHeight: number = this._device.isSamsungNative ? window.outerHeight : window.innerHeight;

		h = innerHeight;
		w = innerWidth;

		if (this._device.isMobile && !this._device.iOS && !this._device.isSamsungNative) {
			ow = window.outerWidth;
			oh = window.outerHeight;

			scaleFactor = h / oh;
		}

		const divisor = this._device.isMobile ? 320 : 640;
		const logoScale = Math.max(0.5, Math.min(window.innerWidth / divisor, 1)) * scaleFactor;
		this._loadingImage.style.transform = `translateX(-50%) translateY(-50%) scale(${logoScale})`;

		this._loadingImage.style.left = Math.ceil(w * 0.5) + 'px';
		this._loadingImage.style.top = Math.ceil(h * 0.65) + 'px';

		this.extraResizeUpdate(w, h, scaleFactor);

		this._loaderBarBg.style.width = Math.ceil(w * 0.8) + 'px';
		this._loaderBarBg.style.height = Math.ceil(40 * scaleFactor) + 'px';
		this._loaderBarBg.style.borderRadius = Math.ceil(20 * scaleFactor) + 'px';
		this._loaderBarBg.style.left = Math.ceil(w * 0.5) + 'px';
		this._loaderBarBg.style.top = Math.ceil(h * 0.65) + 'px';

		this._loaderBarMaxWidth = w * 0.8;

		this._loaderBar.style.width = Math.ceil(this._loaderBarMaxWidth * this._procentageLoaded) + 'px';
		this._loaderBar.style.height = Math.ceil(40 * scaleFactor) + 'px';
		this._loaderBar.style.borderRadius = Math.ceil(20 * scaleFactor) + 'px';
		this._loaderBar.style.left = Math.ceil(w * 0.5) + 'px';
		this._loaderBar.style.top = Math.ceil(h * 0.65) + 'px';

		this._loadingBackground.style.width = Math.ceil(w) + 'px';
		this._loadingBackground.style.height = Math.ceil(h) + 'px';
	}

	protected extraResizeUpdate(width: number, height: number, scaleFactor: number): void {}

	protected createFantasmaLogo(): HTMLImageElement {
        throw new Error('Preloader::createGameLogo should be game specific');
	}

	protected createGameLogo(): HTMLImageElement {
        throw new Error('Preloader::createGameLogo should be game specific');
    }

	protected createPublisherLogoPortrait(): HTMLImageElement {
        throw new Error('Preloader::createPublisherLogoPortrait should be game specific');
	}

    protected createPublisherLogoLandscape(): HTMLImageElement {
        throw new Error('Preloader::createPublisherLogoLandscape should be game specific');
    }

	protected createLoadingPreloaderBg(): HTMLElement {
		const bg: HTMLElement = document.createElement('div');
		bg.style.background = 'radial-gradient(rgb(64, 64, 64), rgb(40, 40, 40), rgb(17, 17, 17))';
		bg.id = 'preloaderBg';
		bg.style.width = '100%';
		bg.style.height = '100%';
		this._loadingBackground = bg;

		return this._loadingBackground;
	}

	protected createLoadingText(): HTMLImageElement {
		const textImage: HTMLImageElement = document.createElement('img');
		textImage.id = 'loadingText';
		textImage.style.position = 'absolute';
		textImage.style.left = '50%';
		textImage.style.transform = 'translateX(-50%) translateY(-50%)';
		textImage.style.top = this._loaderBar.style.top;
		textImage.src = this.getDevicePathForResource('Loading_Text.png');
		this._loadingImage = textImage;

		return this._loadingImage;
	}

	protected createLoadingBarBg(progress?: boolean): HTMLElement {
		let bg: HTMLElement;
		bg = document.createElement('div');

		if (!progress) {
			bg.id = 'barBg';
			bg.style.boxShadow = '0px 5px 10px rgba(0, 0, 0, 0.5)';
			this._loaderBarBg = bg;
		} else {
			bg.id = 'progress';
			this._loaderBar = bg;
		}

		bg.style.position = 'absolute';
		bg.style.width = '80%';
		bg.style.borderRadius = '20px';
		bg.style.height = '40px';
		bg.style.backgroundColor = 'rgb(34, 34, 34)';
		bg.style.display = 'grid';
		bg.style.left = '50%';
		bg.style.top = '65%';
		bg.style.transform = 'translateX(-50%) translateY(-50%)';

		return bg;
	}

	protected createLoadingBarProgress(bg?: HTMLElement): Node {
		const progress = this.createLoadingBarBg(true);
		progress.style.width = '0%';
		progress.style.background = 'rgb(255, 255, 255)';
		// progress.style.border = '3px solid rgb(195, 255, 120)';

		return progress;
	}

	protected calcPercentage(pixels: number): number {
		return pixels / window.innerWidth;
	}

	public updateProgress(totalItems: number, currentItems: number): void {
		const procentage = currentItems / totalItems;

		this._loaderBar.style.width = `${this._loaderBarMaxWidth * procentage}px`;
		this._procentageLoaded = procentage;
	}

	public endLoading(): void {
		window.removeEventListener('resize', this.onResizeEvent);

		if (this._loadingBackground) {
            this._loadingBackground.style.display = 'none';
            this.removeElement(this._loadingBackground);
        }

        if (this._loaderBar) {
            this._loaderBar.style.display = 'none';
            this.removeElement(this._loaderBar);
        }

        if (this._loaderBarBg) {
            this._loaderBarBg.style.display = 'none';
            this.removeElement(this._loaderBarBg);
        }

        if (this._loadingImage) {
            this._loadingImage.style.display = 'none';
            this.removeElement(this._loadingImage);
        }

		this.removeExtraItems();

		if (this._fantasmaLogo) {
            this._fantasmaLogo.style.display = 'none';
            this.removeElement(this._fantasmaLogo);
        }

        if (this._gameLogo) {
            this._gameLogo.style.display = 'none';
            this.removeElement(this._gameLogo);
        }

        if (this._publisherLogoPortrait) {
            this._publisherLogoPortrait.style.display = 'none';
            this.removeElement(this._publisherLogoPortrait);
        }

        if (this._publisherLogoLandscape) {
            this._publisherLogoLandscape.style.display = 'none';
            this.removeElement(this._publisherLogoLandscape);
        }
	}

	protected removeExtraItems(): void {}

	public usingUnsupportedDeviceOrBrowser(): void {
	}

	protected removeElement(element: HTMLElement | HTMLImageElement): void {
		const parent = element.parentElement;
		parent.removeChild(element);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/loader/Preloader.ts